/** EvolveRPG — English overrides for the dashboard feature. Fast-play, momentum-driven voice. */
export const dashboardEvoEn = {
  // DashboardPage
  'dashboard.seo.title': 'My EvolveRPG',
  'dashboard.seo.description': 'Your coins, claims, contributions, and characters — all in one place.',
  'dashboard.displayNameFallback': 'Player One',
  'dashboard.loading': 'Loading your stats…',

  // DashboardPage — Coins card
  'dashboard.coins.title': 'XP Coins',

  // DashboardPage — Contributions card
  'dashboard.contributions.empty': 'No contributions yet — post your first.',

  // DashboardPage — Claims card
  'dashboard.claims.empty': 'You haven’t claimed any ground yet.',

  // DashboardPage — Characters card
  'dashboard.characters.empty': 'No characters built yet.',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.description': 'Shape the face you bring to the table.',
  'dashboard.avatarEditor.errorNameRequired': 'A name is required to build your character.',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Give them a quick backstory — keep it fast.',
  'dashboard.avatarEditor.publicHidden': 'Hidden from other players.',
  // Starting-face picker (UI copy; lineage names and blurbs are setting content in world.config.ts)
  'dashboard.avatarEditor.starting.heading': 'Choose a face from the city',
  'dashboard.avatarEditor.starting.hint': 'Start as one of Montkelian’s peoples. You can upload your own portrait at any time.',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Checkout is not available yet — hang tight.',
  'dashboard.coinHistory.seo.title': 'XP Coins',
  'dashboard.coinHistory.seo.description': 'Your full coin ledger, top-ups, and what you’ve spent them on.',
  'dashboard.coinHistory.heading': 'XP Coins',
  'dashboard.coinHistory.summoningCheckout': 'Loading checkout…',
  'dashboard.coinHistory.tallyingLedger': 'Loading your ledger…',

  // ContributionsPage
  'dashboard.contributionsPage.seo.description':
    'The content you’ve posted, and its progress through review.',
  'dashboard.contributionsPage.loading': 'Loading your contributions…',
  'dashboard.contributionsPage.empty': 'You haven’t posted any content yet. Start your first contribution.',
}
